// src/components/admin/page-management/section-forms/CtaForm.js
import React from 'react';
import ColorPicker from '../../shared/ColorPicker';

const CtaForm = ({ content, updateContent }) => {
  return (
    <div className="space-y-6">
      <h3 className="text-lg font-semibold">Call to Action Section</h3>
      {/* Main Content Settings */}
<div className="bg-gradient-to-br from-slate-50 to-slate-100 dark:from-slate-800 dark:to-slate-900 rounded-xl shadow-lg border border-slate-200 dark:border-slate-700 p-6 mb-6">
  <div className="flex items-center gap-3 mb-6">
    <div className="p-2 bg-blue-500 rounded-lg shadow-sm">
      <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
      </svg>
    </div>
    <h3 className="text-xl font-bold text-slate-800 dark:text-slate-200">Content</h3>
  </div>
  
  <div className="space-y-6">
    <div className="group">
      <label className="flex items-center gap-2 text-sm font-semibold text-slate-700 dark:text-slate-300 mb-3">
        <span className="w-2 h-2 bg-blue-500 rounded-full opacity-75"></span>
        Title
      </label>
      <input
        type="text"
        value={content?.title || ''}
        onChange={(e) => updateContent('title', e.target.value)}
        className="w-full px-4 py-3 bg-white dark:bg-slate-800 border-2 border-slate-200 dark:border-slate-600 rounded-lg 
                   transition-all duration-200 ease-in-out
                   focus:border-blue-500 focus:ring-4 focus:ring-blue-500/20 focus:outline-none
                   hover:border-slate-300 dark:hover:border-slate-500
                   placeholder:text-slate-400 dark:placeholder:text-slate-500
                   text-slate-800 dark:text-slate-200
                   shadow-sm hover:shadow-md focus:shadow-lg"
        placeholder="Enter your title..."
      />
    </div>
    
    <div className="group">
      <label className="flex items-center gap-2 text-sm font-semibold text-slate-700 dark:text-slate-300 mb-3">
        <span className="w-2 h-2 bg-green-500 rounded-full opacity-75"></span>
        Description
      </label>
      <textarea
        value={content?.description || ''}
        onChange={(e) => updateContent('description', e.target.value)}
        className="w-full px-4 py-3 bg-white dark:bg-slate-800 border-2 border-slate-200 dark:border-slate-600 rounded-lg 
                   transition-all duration-200 ease-in-out
                   focus:border-green-500 focus:ring-4 focus:ring-green-500/20 focus:outline-none
                   hover:border-slate-300 dark:hover:border-slate-500
                   placeholder:text-slate-400 dark:placeholder:text-slate-500
                   text-slate-800 dark:text-slate-200
                   shadow-sm hover:shadow-md focus:shadow-lg
                   resize-none"
        rows="3"
        placeholder="Write a compelling description..."
      />
    </div>
    
    <div className="group">
      <label className="flex items-center gap-2 text-sm font-semibold text-slate-700 dark:text-slate-300 mb-3">
        <span className="w-2 h-2 bg-purple-500 rounded-full opacity-75"></span>
        Text Color
      </label>
      <div className="p-4 bg-white dark:bg-slate-800 border-2 border-slate-200 dark:border-slate-600 rounded-lg shadow-sm">
        <ColorPicker
          color={content?.textColor || '#ffffff'}
          onChange={(color) => updateContent('textColor', color)}
        />
      </div>
    </div>
  </div>
</div>
      
      
     {/* Background Settings */}
<div className="bg-white rounded-2xl shadow-xl border border-slate-200 overflow-hidden mb-6">
  {/* Header */}
  <div className="bg-gradient-to-r from-purple-600 to-blue-600 p-6 text-white">
    <div className="flex items-center gap-4">
      <div className="p-3 bg-white/20 rounded-xl backdrop-blur-sm">
        <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 21a4 4 0 01-4-4V5a2 2 0 012-2h4a2 2 0 012 2v12a4 4 0 01-4 4zM21 5a2 2 0 00-2-2h-4a2 2 0 00-2 2v12a4 4 0 004 4h4a2 2 0 002-2V5z" />
        </svg>
      </div>
      <div>
        <h4 className="text-2xl font-bold">Background Settings</h4>
        <p className="text-purple-100">Customize your background appearance</p>
      </div>
    </div>
  </div>

  <div className="p-8 space-y-8">
    {/* Background Color */}
    <div>
      <h5 className="text-lg font-bold text-slate-800 mb-4 flex items-center gap-2">
        <span className="w-3 h-3 bg-blue-500 rounded-full"></span>
        Background Color
      </h5>
      <div className="relative group">
        <div className="flex items-center gap-4 p-4 bg-white rounded-xl border-2 border-slate-200 hover:border-slate-300 transition-all duration-200 shadow-sm hover:shadow-md">
          <div className="relative">
            <ColorPicker
              color={content?.backgroundColor || '#013263'}
              onChange={(color) => updateContent('backgroundColor', color)}
            />
          </div>
          
        </div>
      </div>
    </div>

    {/* Gradient Toggle */}
    <div>
      <h5 className="text-lg font-bold text-slate-800 mb-4 flex items-center gap-2">
        <span className="w-3 h-3 bg-green-500 rounded-full"></span>
        Gradient Effects
      </h5>
      <div className="flex items-center justify-between p-4 bg-white rounded-xl border-2 border-slate-200 hover:border-slate-300 transition-all duration-200 shadow-sm hover:shadow-md group">
        <div className="flex-1">
          <p className="font-semibold text-slate-700 mb-1">Enable Gradient Background</p>
          <p className="text-sm text-slate-500">Add beautiful gradient effects to your background</p>
        </div>
        <button
          onClick={() => updateContent('gradientEnabled', !(content?.gradientEnabled !== false))}
          className={`relative w-14 h-8 rounded-full transition-all duration-300 shadow-inner ${
            content?.gradientEnabled !== false
              ? 'bg-gradient-to-r from-green-400 to-green-500 shadow-green-200' 
              : 'bg-slate-300 shadow-slate-200'
          }`}
        >
          <div
            className={`absolute top-1 w-6 h-6 bg-white rounded-full shadow-lg transition-all duration-300 transform ${
              content?.gradientEnabled !== false ? 'translate-x-7' : 'translate-x-1'
            }`}
          >
            <div className={`w-full h-full rounded-full flex items-center justify-center ${
              content?.gradientEnabled !== false ? 'text-green-500' : 'text-slate-400'
            }`}>
              {content?.gradientEnabled !== false ? (
                <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                </svg>
              ) : (
                <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                </svg>
              )}
            </div>
          </div>
        </button>
      </div>
    </div>

    {/* Gradient Direction */}
    {content?.gradientEnabled !== false && (
      <div className="bg-gradient-to-r from-blue-50 to-purple-50 p-6 rounded-xl border border-blue-100">
        <h5 className="text-lg font-bold text-slate-800 mb-4 flex items-center gap-2">
          <span className="w-3 h-3 bg-purple-500 rounded-full"></span>
          Gradient Direction
        </h5>
        <p className="text-slate-600 mb-4">Choose how your gradient flows across the background</p>
        
        <div className="grid grid-cols-2 gap-3">
          {[
            { value: 'to right', label: 'Left to Right', icon: '→', preview: 'linear-gradient(to right, #3b82f6, #8b5cf6)' },
            { value: 'to left', label: 'Right to Left', icon: '←', preview: 'linear-gradient(to left, #3b82f6, #8b5cf6)' },
            { value: 'to bottom', label: 'Top to Bottom', icon: '↓', preview: 'linear-gradient(to bottom, #3b82f6, #8b5cf6)' },
            { value: 'to top', label: 'Bottom to Top', icon: '↑', preview: 'linear-gradient(to top, #3b82f6, #8b5cf6)' },
            { value: 'to bottom right', label: 'Diagonal ↘', icon: '↘', preview: 'linear-gradient(to bottom right, #3b82f6, #8b5cf6)' },
            { value: 'to bottom left', label: 'Diagonal ↙', icon: '↙', preview: 'linear-gradient(to bottom left, #3b82f6, #8b5cf6)' },
            { value: 'to top right', label: 'Diagonal ↗', icon: '↗', preview: 'linear-gradient(to top right, #3b82f6, #8b5cf6)' },
            { value: 'to top left', label: 'Diagonal ↖', icon: '↖', preview: 'linear-gradient(to top left, #3b82f6, #8b5cf6)' }
          ].map((direction) => (
            <button
              key={direction.value}
              onClick={() => updateContent('gradientDirection', direction.value)}
              className={`p-3 rounded-xl border-2 transition-all duration-200 group ${
                (content?.gradientDirection || 'to right') === direction.value
                  ? 'border-blue-500 bg-blue-50 shadow-lg scale-105'
                  : 'border-slate-200 bg-white hover:border-slate-300 hover:shadow-md'
              }`}
            >
              <div 
                className="w-full h-8 rounded-lg mb-2 shadow-inner"
                style={{ background: direction.preview }}
              ></div>
              <div className="flex items-center justify-center gap-2">
                <span className="text-lg">{direction.icon}</span>
                <span className={`text-xs font-medium ${
                  (content?.gradientDirection || 'to right') === direction.value ? 'text-blue-700' : 'text-slate-600'
                }`}>
                  {direction.label}
                </span>
              </div>
            </button>
          ))}
        </div>
      </div>
    )}

    {/* Background Effects Toggle */}
    <div>
      <h5 className="text-lg font-bold text-slate-800 mb-4 flex items-center gap-2">
        <span className="w-3 h-3 bg-amber-500 rounded-full"></span>
        Additional Effects
      </h5>
      <div className="flex items-center justify-between p-4 bg-white rounded-xl border-2 border-slate-200 hover:border-slate-300 transition-all duration-200 shadow-sm hover:shadow-md group">
        <div className="flex-1">
          <p className="font-semibold text-slate-700 mb-1">Gradient Overlay Effects</p>
          <p className="text-sm text-slate-500">Add extra visual depth with overlay effects</p>
        </div>
        <button
          onClick={() => updateContent('showBackgroundEffects', !(content?.showBackgroundEffects !== false))}
          className={`relative w-14 h-8 rounded-full transition-all duration-300 shadow-inner ${
            content?.showBackgroundEffects !== false
              ? 'bg-gradient-to-r from-amber-400 to-amber-500 shadow-amber-200' 
              : 'bg-slate-300 shadow-slate-200'
          }`}
        >
          <div
            className={`absolute top-1 w-6 h-6 bg-white rounded-full shadow-lg transition-all duration-300 transform ${
              content?.showBackgroundEffects !== false ? 'translate-x-7' : 'translate-x-1'
            }`}
          >
            <div className={`w-full h-full rounded-full flex items-center justify-center ${
              content?.showBackgroundEffects !== false ? 'text-amber-500' : 'text-slate-400'
            }`}>
              {content?.showBackgroundEffects !== false ? (
                <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                </svg>
              ) : (
                <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                </svg>
              )}
            </div>
          </div>
        </button>
      </div>
    </div>

    {/* Live Preview */}
    <div>
      <h5 className="text-lg font-bold text-slate-800 mb-4 flex items-center gap-2">
        <span className="w-3 h-3 bg-emerald-500 rounded-full"></span>
        Live Preview
      </h5>
      <div className="relative rounded-xl overflow-hidden shadow-lg border-2 border-slate-200">
        <div 
          className="h-32 flex items-center justify-center relative"
          style={{ 
            background: content?.gradientEnabled !== false 
              ? `linear-gradient(${content?.gradientDirection || 'to right'}, ${content?.backgroundColor || '#013263'}, ${content?.backgroundColor || '#013263'}88)`
              : content?.backgroundColor || '#013263'
          }}
        >
          {content?.showBackgroundEffects !== false && (
            <div className="absolute inset-0 bg-gradient-to-br from-white/10 to-transparent"></div>
          )}
          <div className="text-white text-center z-10">
            <p className="text-lg font-bold">Your Background</p>
            <p className="text-sm opacity-90">This is how it will look</p>
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>
      
     {/* Primary Button Settings */}
<div className="bg-white rounded-2xl shadow-xl border border-slate-200 overflow-hidden mb-6">
  {/* Header */}
  <div className="bg-gradient-to-r from-emerald-600 to-teal-600 p-6 text-white">
    <div className="flex items-center gap-4">
      <div className="p-3 bg-white/20 rounded-xl backdrop-blur-sm">
        <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1" />
        </svg>
      </div>
      <div>
        <h4 className="text-2xl font-bold">Primary Button</h4>
        <p className="text-emerald-100">Configure your main call-to-action button</p>
      </div>
    </div>
  </div>

  <div className="p-8 space-y-8">
    {/* Show Button Toggle */}
    <div>
      <h5 className="text-lg font-bold text-slate-800 mb-4 flex items-center gap-2">
        <span className="w-3 h-3 bg-emerald-500 rounded-full"></span>
        Button Visibility
      </h5>
      <div className="flex items-center justify-between p-4 bg-white rounded-xl border-2 border-slate-200 hover:border-slate-300 transition-all duration-200 shadow-sm hover:shadow-md group">
        <div className="flex-1">
          <p className="font-semibold text-slate-700 mb-1">Show Primary Button</p>
          <p className="text-sm text-slate-500">Display the main call-to-action button</p>
        </div>
        <button
          onClick={() => updateContent('showPrimaryButton', !(content?.showPrimaryButton !== false))}
          className={`relative w-14 h-8 rounded-full transition-all duration-300 shadow-inner ${
            content?.showPrimaryButton !== false
              ? 'bg-gradient-to-r from-emerald-400 to-emerald-500 shadow-emerald-200' 
              : 'bg-slate-300 shadow-slate-200'
          }`}
        >
          <div
            className={`absolute top-1 w-6 h-6 bg-white rounded-full shadow-lg transition-all duration-300 transform ${
              content?.showPrimaryButton !== false ? 'translate-x-7' : 'translate-x-1'
            }`}
          >
            <div className={`w-full h-full rounded-full flex items-center justify-center ${
              content?.showPrimaryButton !== false ? 'text-emerald-500' : 'text-slate-400'
            }`}>
              {content?.showPrimaryButton !== false ? (
                <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                </svg>
              ) : (
                <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                </svg>
              )}
            </div>
          </div>
        </button>
      </div>
    </div>

    {content?.showPrimaryButton !== false && (
      <>
        {/* Button Content */}
        <div className="space-y-6">
          <div>
            <h5 className="text-lg font-bold text-slate-800 mb-4 flex items-center gap-2">
              <span className="w-3 h-3 bg-blue-500 rounded-full"></span>
              Button Content
            </h5>
            
            <div className="space-y-4">
              {/* Button Text */}
              <div className="group">
                <label className="flex items-center gap-2 text-sm font-semibold text-slate-700 dark:text-slate-300 mb-3">
                  <svg className="w-4 h-4 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z" />
                  </svg>
                  Button Text
                </label>
                <input
                  type="text"
                  value={content?.primaryButtonText || 'Browse Products'}
                  onChange={(e) => updateContent('primaryButtonText', e.target.value)}
                  className="w-full px-4 py-3 bg-white dark:bg-slate-800 border-2 border-slate-200 dark:border-slate-600 rounded-lg 
                             transition-all duration-200 ease-in-out
                             focus:border-blue-500 focus:ring-4 focus:ring-blue-500/20 focus:outline-none
                             hover:border-slate-300 dark:hover:border-slate-500
                             placeholder:text-slate-400 dark:placeholder:text-slate-500
                             text-slate-800 dark:text-slate-200
                             shadow-sm hover:shadow-md focus:shadow-lg"
                  placeholder="Enter button text..."
                />
              </div>
              
              {/* Button Link */}
              <div className="group">
                <label className="flex items-center gap-2 text-sm font-semibold text-slate-700 dark:text-slate-300 mb-3">
                  <svg className="w-4 h-4 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1" />
                  </svg>
                  Button Link
                </label>
                <input
                  type="text"
                  value={content?.primaryButtonLink || '/products'}
                  onChange={(e) => updateContent('primaryButtonLink', e.target.value)}
                  className="w-full px-4 py-3 bg-white dark:bg-slate-800 border-2 border-slate-200 dark:border-slate-600 rounded-lg 
                             transition-all duration-200 ease-in-out
                             focus:border-green-500 focus:ring-4 focus:ring-green-500/20 focus:outline-none
                             hover:border-slate-300 dark:hover:border-slate-500
                             placeholder:text-slate-400 dark:placeholder:text-slate-500
                             text-slate-800 dark:text-slate-200
                             shadow-sm hover:shadow-md focus:shadow-lg"
                  placeholder="Enter URL or path..."
                />
              </div>
            </div>
          </div>

          {/* Button Colors */}
          <div>
            <h5 className="text-lg font-bold text-slate-800 mb-4 flex items-center gap-2">
              <span className="w-3 h-3 bg-purple-500 rounded-full"></span>
              Button Colors
            </h5>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {/* Button Background Color */}
              <div className="relative group">
                <div className="flex items-center gap-4 p-4 bg-white rounded-xl border-2 border-slate-200 hover:border-slate-300 transition-all duration-200 shadow-sm hover:shadow-md">
                  <div className="relative">
                  <p className="font-semibold text-slate-700 mb-1">Button Background</p>

                    <ColorPicker
                      color={content?.primaryButtonColor || '#ffffff'}
                      onChange={(color) => updateContent('primaryButtonColor', color)}
                    />
                  </div>
                  
                </div>
              </div>
              
              {/* Button Text Color */}
              <div className="relative group">
                <div className="flex items-center gap-4 p-4 bg-white rounded-xl border-2 border-slate-200 hover:border-slate-300 transition-all duration-200 shadow-sm hover:shadow-md">
                  <div className="relative">
                  <p className="font-semibold text-slate-700 mb-1">Button Text</p>

                    <ColorPicker
                      color={content?.primaryButtonTextColor || '#1e40af'}
                      onChange={(color) => updateContent('primaryButtonTextColor', color)}
                    />
                  </div>
                  
                </div>
              </div>
            </div>
          </div>

          {/* Live Preview */}
          <div>
            <h5 className="text-lg font-bold text-slate-800 mb-4 flex items-center gap-2">
              <span className="w-3 h-3 bg-amber-500 rounded-full"></span>
              Button Preview
            </h5>
            <div className="flex items-center justify-center p-8 bg-gradient-to-br from-slate-50 to-slate-100 rounded-xl border border-slate-200">
              <button
                className="px-8 py-4 rounded-lg font-semibold text-lg shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-200"
                style={{
                  backgroundColor: content?.primaryButtonColor || '#ffffff',
                  color: content?.primaryButtonTextColor || '#1e40af'
                }}
              >
                {content?.primaryButtonText || 'Browse Products'}
              </button>
            </div>
            <p className="text-center text-sm text-slate-500 mt-2">
              This is how your button will appear to users
            </p>
          </div>
        </div>
      </>
    )}
  </div>
</div>
      {/* Secondary Button Settings */}
<div className="bg-white rounded-2xl shadow-xl border border-slate-200 overflow-hidden mb-6">
  {/* Header */}
  <div className="bg-gradient-to-r from-amber-600 to-orange-600 p-6 text-white">
    <div className="flex items-center gap-4">
      
      <div>
        <h4 className="text-2xl font-bold">Secondary Button</h4>
        <p className="text-amber-100">Configure your secondary call-to-action button</p>
      </div>
    </div>
  </div>

  <div className="p-8 space-y-8">
    {/* Show Button Toggle */}
    <div>
      <h5 className="text-lg font-bold text-slate-800 mb-4 flex items-center gap-2">
        <span className="w-3 h-3 bg-orange-500 rounded-full"></span>
        Button Visibility
      </h5>
      <div className="flex items-center justify-between p-4 bg-white rounded-xl border-2 border-slate-200 hover:border-slate-300 transition-all duration-200 shadow-sm hover:shadow-md group">
        <div className="flex-1">
          <p className="font-semibold text-slate-700 mb-1">Show Secondary Button</p>
          <p className="text-sm text-slate-500">Display the secondary call-to-action button</p>
        </div>
        <button
          onClick={() => updateContent('showSecondaryButton', !(content?.showSecondaryButton !== false))}
          className={`relative w-14 h-8 rounded-full transition-all duration-300 shadow-inner ${
            content?.showSecondaryButton !== false
              ? 'bg-gradient-to-r from-orange-400 to-orange-500 shadow-orange-200' 
              : 'bg-slate-300 shadow-slate-200'
          }`}
        >
          <div
            className={`absolute top-1 w-6 h-6 bg-white rounded-full shadow-lg transition-all duration-300 transform ${
              content?.showSecondaryButton !== false ? 'translate-x-7' : 'translate-x-1'
            }`}
          >
            <div className={`w-full h-full rounded-full flex items-center justify-center ${
              content?.showSecondaryButton !== false ? 'text-orange-500' : 'text-slate-400'
            }`}>
              {content?.showSecondaryButton !== false ? (
                <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                </svg>
              ) : (
                <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                </svg>
              )}
            </div>
          </div>
        </button>
      </div>
    </div>

    {content?.showSecondaryButton !== false && (
      <>
        {/* Button Content */}
        <div className="space-y-6">
          <div>
            <h5 className="text-lg font-bold text-slate-800 mb-4 flex items-center gap-2">
              <span className="w-3 h-3 bg-blue-500 rounded-full"></span>
              Button Content
            </h5>
            
            <div className="space-y-4">
              {/* Button Text */}
              <div className="group">
                <label className="flex items-center gap-2 text-sm font-semibold text-slate-700 dark:text-slate-300 mb-3">
                  <svg className="w-4 h-4 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z" />
                  </svg>
                  Button Text
                </label>
                <input
                  type="text"
                  value={content?.secondaryButtonText || 'Contact Us'}
                  onChange={(e) => updateContent('secondaryButtonText', e.target.value)}
                  className="w-full px-4 py-3 bg-white dark:bg-slate-800 border-2 border-slate-200 dark:border-slate-600 rounded-lg 
                             transition-all duration-200 ease-in-out
                             focus:border-blue-500 focus:ring-4 focus:ring-blue-500/20 focus:outline-none
                             hover:border-slate-300 dark:hover:border-slate-500
                             placeholder:text-slate-400 dark:placeholder:text-slate-500
                             text-slate-800 dark:text-slate-200
                             shadow-sm hover:shadow-md focus:shadow-lg"
                  placeholder="Enter button text..."
                />
              </div>
              
              {/* Button Link */}
              <div className="group">
                <label className="flex items-center gap-2 text-sm font-semibold text-slate-700 dark:text-slate-300 mb-3">
                  <svg className="w-4 h-4 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1" />
                  </svg>
                  Button Link
                </label>
                <input
                  type="text"
                  value={content?.secondaryButtonLink || 'tel:+18333333101'}
                  onChange={(e) => updateContent('secondaryButtonLink', e.target.value)}
                  className="w-full px-4 py-3 bg-white dark:bg-slate-800 border-2 border-slate-200 dark:border-slate-600 rounded-lg 
                             transition-all duration-200 ease-in-out
                             focus:border-green-500 focus:ring-4 focus:ring-green-500/20 focus:outline-none
                             hover:border-slate-300 dark:hover:border-slate-500
                             placeholder:text-slate-400 dark:placeholder:text-slate-500
                             text-slate-800 dark:text-slate-200
                             shadow-sm hover:shadow-md focus:shadow-lg"
                  placeholder="tel:+1234567890 or mailto:email@example.com"
                />
              </div>
            </div>
          </div>

          {/* Phone Configuration */}
          <div className="bg-gradient-to-r from-indigo-50 to-cyan-50 p-6 rounded-xl border border-indigo-100">
            <h5 className="text-lg font-bold text-slate-800 mb-4 flex items-center gap-2">
              <span className="w-3 h-3 bg-indigo-500 rounded-full"></span>
              Phone Configuration
            </h5>
            <p className="text-slate-600 mb-4">Configure phone number settings for contact buttons</p>
            
            <div className="space-y-4">
              {/* Phone Number */}
              <div className="group">
                <label className="flex items-center gap-2 text-sm font-semibold text-slate-700 dark:text-slate-300 mb-3">
                  <svg className="w-4 h-4 text-indigo-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                  </svg>
                  Phone Number
                </label>
                <input
                  type="text"
                  value={content?.phoneNumber || '+18333333101'}
                  onChange={(e) => updateContent('phoneNumber', e.target.value)}
                  className="w-full px-4 py-3 bg-white dark:bg-slate-800 border-2 border-slate-200 dark:border-slate-600 rounded-lg 
                             transition-all duration-200 ease-in-out
                             focus:border-indigo-500 focus:ring-4 focus:ring-indigo-500/20 focus:outline-none
                             hover:border-slate-300 dark:hover:border-slate-500
                             placeholder:text-slate-400 dark:placeholder:text-slate-500
                             text-slate-800 dark:text-slate-200
                             shadow-sm hover:shadow-md focus:shadow-lg"
                  placeholder="+1 (555) 123-4567"
                />
                <p className="text-xs text-slate-500 mt-2 flex items-center gap-1">
                  <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                  </svg>
                  Used when the button links to a phone number
                </p>
              </div>

              {/* Phone Icon Toggle */}
              <div className="flex items-center justify-between p-4 bg-white rounded-xl border-2 border-slate-200 hover:border-slate-300 transition-all duration-200 shadow-sm hover:shadow-md group">
                <div className="flex-1">
                  <p className="font-semibold text-slate-700 mb-1">Show Phone Icon</p>
                  <p className="text-sm text-slate-500">Display a phone icon next to the button text</p>
                </div>
                <button
                  onClick={() => updateContent('showPhoneIcon', !(content?.showPhoneIcon !== false))}
                  className={`relative w-14 h-8 rounded-full transition-all duration-300 shadow-inner ${
                    content?.showPhoneIcon !== false
                      ? 'bg-gradient-to-r from-indigo-400 to-indigo-500 shadow-indigo-200' 
                      : 'bg-slate-300 shadow-slate-200'
                  }`}
                >
                  <div
                    className={`absolute top-1 w-6 h-6 bg-white rounded-full shadow-lg transition-all duration-300 transform ${
                      content?.showPhoneIcon !== false ? 'translate-x-7' : 'translate-x-1'
                    }`}
                  >
                    <div className={`w-full h-full rounded-full flex items-center justify-center ${
                      content?.showPhoneIcon !== false ? 'text-indigo-500' : 'text-slate-400'
                    }`}>
                      {content?.showPhoneIcon !== false ? (
                        <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                        </svg>
                      ) : (
                        <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                        </svg>
                      )}
                    </div>
                  </div>
                </button>
              </div>
            </div>
          </div>

          {/* Button Colors */}
          <div>
            <h5 className="text-lg font-bold text-slate-800 mb-4 flex items-center gap-2">
              <span className="w-3 h-3 bg-purple-500 rounded-full"></span>
              Button Colors
            </h5>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {/* Button Background Color */}
              <div className="relative group">
                <div className="flex items-center gap-4 p-4 bg-white rounded-xl border-2 border-slate-200 hover:border-slate-300 transition-all duration-200 shadow-sm hover:shadow-md">
                  <div className="relative">
                  <p className="font-semibold text-slate-700 mb-1">Button Background</p>

                    <ColorPicker
                      color={content?.secondaryButtonColor || '#b45309'}
                      onChange={(color) => updateContent('secondaryButtonColor', color)}
                    />
                  </div>
                 
                </div>
              </div>
              
              {/* Button Text Color */}
              <div className="relative group">
                <div className="flex items-center gap-4 p-4 bg-white rounded-xl border-2 border-slate-200 hover:border-slate-300 transition-all duration-200 shadow-sm hover:shadow-md">
                  <div className="relative">
                  <p className="font-semibold text-slate-700 mb-1">Button Text</p>

                    <ColorPicker
                      color={content?.secondaryButtonTextColor || '#ffffff'}
                      onChange={(color) => updateContent('secondaryButtonTextColor', color)}
                    />
                  </div>
                 
                </div>
              </div>
            </div>
          </div>

          {/* Live Preview */}
          <div>
            <h5 className="text-lg font-bold text-slate-800 mb-4 flex items-center gap-2">
              <span className="w-3 h-3 bg-amber-500 rounded-full"></span>
              Button Preview
            </h5>
            <div className="flex items-center justify-center p-8 bg-gradient-to-br from-slate-50 to-slate-100 rounded-xl border border-slate-200">
              <button
                className="px-8 py-4 rounded-lg font-semibold text-lg shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-200 flex items-center gap-3"
                style={{
                  backgroundColor: content?.secondaryButtonColor || '#b45309',
                  color: content?.secondaryButtonTextColor || '#ffffff'
                }}
              >
                {content?.showPhoneIcon !== false && (
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                  </svg>
                )}
                {content?.secondaryButtonText || 'Contact Us'}
              </button>
            </div>
            <p className="text-center text-sm text-slate-500 mt-2">
              This is how your secondary button will appear to users
            </p>
          </div>
        </div>
      </>
    )}
  </div>
</div>
      
      {/* Spacing & Animation Settings */}
<div className="bg-white rounded-2xl shadow-xl border border-slate-200 overflow-hidden mb-6">
  {/* Header */}
  <div className="bg-gradient-to-r from-violet-600 to-purple-600 p-6 text-white">
    <div className="flex items-center gap-4">
      <div className="p-3 bg-white/20 rounded-xl backdrop-blur-sm">
        <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 8V4m0 0h4M4 4l5 5m11-1V4m0 0h-4m4 0l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5l-5-5m5 5v-4m0 4h-4" />
        </svg>
      </div>
      <div>
        <h4 className="text-2xl font-bold">Spacing & Animation</h4>
        <p className="text-violet-100">Control layout spacing and motion effects</p>
      </div>
    </div>
  </div>

  <div className="p-8 space-y-8">
    {/* Spacing Controls */}
    <div>
      <h5 className="text-lg font-bold text-slate-800 mb-4 flex items-center gap-2">
        <span className="w-3 h-3 bg-blue-500 rounded-full"></span>
        Layout Spacing
      </h5>
      <p className="text-slate-600 mb-6">Control the spacing around your section content</p>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {/* Top Padding */}
        <div className="group">
          <label className="flex items-center gap-2 text-sm font-semibold text-slate-700 mb-3">
            <div className="w-6 h-6 bg-gradient-to-b from-blue-100 to-blue-200 rounded border-2 border-blue-300 flex items-start justify-center pt-1">
              <div className="w-2 h-1 bg-blue-500 rounded-sm"></div>
            </div>
            Top Padding
          </label>
          <input
            type="text"
            value={content?.paddingTop || '8rem'}
            onChange={(e) => updateContent('paddingTop', e.target.value)}
            className="w-full px-4 py-3 bg-white border-2 border-slate-200 rounded-lg 
                       transition-all duration-200 ease-in-out
                       focus:border-blue-500 focus:ring-4 focus:ring-blue-500/20 focus:outline-none
                       hover:border-slate-300
                       placeholder:text-slate-400
                       text-slate-800
                       shadow-sm hover:shadow-md focus:shadow-lg"
            placeholder="e.g., 8rem, 128px"
          />
        </div>
        
        {/* Bottom Padding */}
        <div className="group">
          <label className="flex items-center gap-2 text-sm font-semibold text-slate-700 mb-3">
            <div className="w-6 h-6 bg-gradient-to-t from-green-100 to-green-200 rounded border-2 border-green-300 flex items-end justify-center pb-1">
              <div className="w-2 h-1 bg-green-500 rounded-sm"></div>
            </div>
            Bottom Padding
          </label>
          <input
            type="text"
            value={content?.paddingBottom || '10rem'}
            onChange={(e) => updateContent('paddingBottom', e.target.value)}
            className="w-full px-4 py-3 bg-white border-2 border-slate-200 rounded-lg 
                       transition-all duration-200 ease-in-out
                       focus:border-green-500 focus:ring-4 focus:ring-green-500/20 focus:outline-none
                       hover:border-slate-300
                       placeholder:text-slate-400
                       text-slate-800
                       shadow-sm hover:shadow-md focus:shadow-lg"
            placeholder="e.g., 10rem, 160px"
          />
        </div>
        
        {/* Bottom Margin */}
        <div className="group">
          <label className="flex items-center gap-2 text-sm font-semibold text-slate-700 mb-3">
            <div className="w-6 h-6 bg-gradient-to-b from-purple-100 to-purple-200 rounded border-2 border-purple-300 flex flex-col items-center justify-center gap-0.5">
              <div className="w-2 h-1 bg-purple-500 rounded-sm"></div>
              <div className="w-3 h-0.5 bg-purple-300 rounded-sm"></div>
            </div>
            Bottom Margin
          </label>
          <input
            type="text"
            value={content?.marginBottom || '5rem'}
            onChange={(e) => updateContent('marginBottom', e.target.value)}
            className="w-full px-4 py-3 bg-white border-2 border-slate-200 rounded-lg 
                       transition-all duration-200 ease-in-out
                       focus:border-purple-500 focus:ring-4 focus:ring-purple-500/20 focus:outline-none
                       hover:border-slate-300
                       placeholder:text-slate-400
                       text-slate-800
                       shadow-sm hover:shadow-md focus:shadow-lg"
            placeholder="e.g., 5rem, 80px"
          />
        </div>
      </div>
      
      {/* Spacing Guide */}
      <div className="mt-4 p-4 bg-slate-50 rounded-lg border border-slate-200">
        <div className="flex items-center gap-2 text-sm text-slate-600 mb-2">
          <svg className="w-4 h-4 text-slate-500" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
          </svg>
          <span className="font-medium">Spacing Guide:</span>
        </div>
        <div className="text-xs text-slate-500 space-y-1">
          <p><span className="font-mono bg-white px-1 rounded">rem</span> units: 1rem = 16px (responsive)</p>
          <p><span className="font-mono bg-white px-1 rounded">px</span> units: Fixed pixel values</p>
          <p><span className="font-mono bg-white px-1 rounded">%</span> units: Percentage of container</p>
        </div>
      </div>
    </div>

    {/* Animation Controls */}
    <div>
      <h5 className="text-lg font-bold text-slate-800 mb-4 flex items-center gap-2">
        <span className="w-3 h-3 bg-pink-500 rounded-full"></span>
        Animation Effects
      </h5>
      <p className="text-slate-600 mb-6">Add smooth animations to enhance user experience</p>
      
      <div className="space-y-6">
        {/* Enable Animation Toggle */}
        <div className="flex items-center justify-between p-4 bg-white rounded-xl border-2 border-slate-200 hover:border-slate-300 transition-all duration-200 shadow-sm hover:shadow-md group">
          <div className="flex items-center gap-4">
            <div className="p-2 bg-pink-100 rounded-lg">
              <svg className="w-5 h-5 text-pink-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
              </svg>
            </div>
            <div className="flex-1">
              <p className="font-semibold text-slate-700 mb-1">Enable Animation</p>
              <p className="text-sm text-slate-500">Add smooth fade-in and slide effects</p>
            </div>
          </div>
          <button
            onClick={() => updateContent('animationEnabled', !(content?.animationEnabled !== false))}
            className={`relative w-14 h-8 rounded-full transition-all duration-300 shadow-inner ${
              content?.animationEnabled !== false
                ? 'bg-gradient-to-r from-pink-400 to-pink-500 shadow-pink-200' 
                : 'bg-slate-300 shadow-slate-200'
            }`}
          >
            <div
              className={`absolute top-1 w-6 h-6 bg-white rounded-full shadow-lg transition-all duration-300 transform ${
                content?.animationEnabled !== false ? 'translate-x-7' : 'translate-x-1'
              }`}
            >
              <div className={`w-full h-full rounded-full flex items-center justify-center ${
                content?.animationEnabled !== false ? 'text-pink-500' : 'text-slate-400'
              }`}>
                {content?.animationEnabled !== false ? (
                  <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M13 10V3L4 14h7v7l9-11h-7z" />
                  </svg>
                ) : (
                  <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                  </svg>
                )}
              </div>
            </div>
          </button>
        </div>

        {/* Stagger Animation (conditional) */}
        {content?.animationEnabled !== false && (
          <div className="bg-gradient-to-r from-pink-50 to-rose-50 p-6 rounded-xl border border-pink-100">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-4">
                <div className="p-2 bg-rose-100 rounded-lg">
                  <svg className="w-5 h-5 text-rose-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M9 19l3 3m0 0l3-3m-3 3V10" />
                  </svg>
                </div>
                <div className="flex-1">
                  <p className="font-semibold text-slate-700 mb-1">Stagger Animation</p>
                  <p className="text-sm text-slate-500">Elements fade in one after another for a cascading effect</p>
                </div>
              </div>
              <button
                onClick={() => updateContent('animationStagger', !(content?.animationStagger !== false))}
                className={`relative w-14 h-8 rounded-full transition-all duration-300 shadow-inner ${
                  content?.animationStagger !== false
                    ? 'bg-gradient-to-r from-rose-400 to-rose-500 shadow-rose-200' 
                    : 'bg-slate-300 shadow-slate-200'
                }`}
              >
                <div
                  className={`absolute top-1 w-6 h-6 bg-white rounded-full shadow-lg transition-all duration-300 transform ${
                    content?.animationStagger !== false ? 'translate-x-7' : 'translate-x-1'
                  }`}
                >
                  <div className={`w-full h-full rounded-full flex items-center justify-center ${
                    content?.animationStagger !== false ? 'text-rose-500' : 'text-slate-400'
                  }`}>
                    {content?.animationStagger !== false ? (
                      <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
                      </svg>
                    ) : (
                      <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                      </svg>
                    )}
                  </div>
                </div>
              </button>
            </div>
          </div>
        )}
      </div>
    </div>

    {/* Visual Preview */}
    <div>
      <h5 className="text-lg font-bold text-slate-800 mb-4 flex items-center gap-2">
        <span className="w-3 h-3 bg-emerald-500 rounded-full"></span>
        Layout Preview
      </h5>
      <div className="bg-slate-100 rounded-xl p-6 border border-slate-200">
        <div className="bg-white rounded-lg shadow-sm border border-slate-200 overflow-hidden">
          {/* Top Padding Visualization */}
          <div className="bg-blue-50 border-b border-blue-200 flex items-center justify-center text-xs text-blue-600 font-medium h-8">
            Top Padding: {content?.paddingTop || '8rem'}
          </div>
          
          {/* Content Area */}
          <div className="p-6 bg-white">
            <div className="text-center space-y-3">
              <div className="w-16 h-2 bg-slate-300 rounded mx-auto"></div>
              <div className="w-24 h-1.5 bg-slate-200 rounded mx-auto"></div>
              <div className="w-20 h-8 bg-gradient-to-r from-blue-500 to-purple-500 rounded mx-auto flex items-center justify-center">
                <span className="text-xs text-white font-medium">Section Content</span>
              </div>
            </div>
          </div>
          
          {/* Bottom Padding Visualization */}
          <div className="bg-green-50 border-t border-green-200 flex items-center justify-center text-xs text-green-600 font-medium h-8">
            Bottom Padding: {content?.paddingBottom || '10rem'}
          </div>
        </div>
        
        {/* Bottom Margin Visualization */}
        <div className="bg-purple-50 border border-purple-200 rounded-lg mt-2 flex items-center justify-center text-xs text-purple-600 font-medium h-6">
          Bottom Margin: {content?.marginBottom || '5rem'}
        </div>
      </div>
    </div>
  </div>
</div>
      
    </div>
  );
};

export default CtaForm;







// //very simple
// // src/components/admin/page-management/section-forms/CtaForm.js
// import React from 'react';
// import ImageUploader from '../ImageUploader';

// const CtaForm = ({ content, updateContent, pageSlug }) => {
//   return (
//     <div>
//       <h3 className="font-bold text-lg mb-4">Call to Action Section</h3>
      
//       {/* Content Settings */}
//       <div className="mb-4">
//         <label className="block text-sm font-medium mb-1">Title</label>
//         <input
//           type="text"
//           className="w-full p-2 border rounded"
//           value={content?.ctaTitle || ''}
//           onChange={(e) => updateContent('ctaTitle', e.target.value)}
//         />
//       </div>
      
//       <div className="mb-4">
//         <label className="block text-sm font-medium mb-1">Text</label>
//         <textarea
//           className="w-full p-2 border rounded"
//           rows="3"
//           value={content?.ctaText || ''}
//           onChange={(e) => updateContent('ctaText', e.target.value)}
//         ></textarea>
//       </div>
      
//       {/* Background Image */}
//       <div className="mb-4">
//         <label className="block text-sm font-medium mb-1">Background Image URL</label>
//         <input
//           type="text"
//           className="w-full p-2 border rounded"
//           value={content?.backgroundImageUrl || ''}
//           onChange={(e) => updateContent('backgroundImageUrl', e.target.value)}
//         />
//         {pageSlug && (
//           <ImageUploader 
//             onImageUpload={(path) => updateContent('backgroundImageUrl', path)} 
//             pageSlug={pageSlug} 
//           />
//         )}
        
//         {content?.backgroundImageUrl && (
//           <div className="mt-2 p-2 border rounded">
//             <img 
//               src={content.backgroundImageUrl} 
//               alt="CTA background"
//               className="max-w-full h-auto max-h-32 mx-auto"
//             />
//           </div>
//         )}
//       </div>
      
//       {/* Overlay Settings */}
//       <div className="mb-4 p-3 border rounded bg-gray-50">
//         <h4 className="font-medium mb-2">Background Overlay</h4>
        
//         <div className="flex items-center mb-2">
//           <input
//             type="checkbox"
//             className="mr-2"
//             checked={content?.overlay?.enabled || false}
//             onChange={(e) => updateContent('overlay', {
//               ...content.overlay,
//               enabled: e.target.checked
//             })}
//           />
//           <label className="text-sm">Enable overlay</label>
//         </div>
        
//         {content?.overlay?.enabled && (
//           <>
//             <div className="mb-2">
//               <label className="block text-sm mb-1">Overlay Color</label>
//               <input
//                 type="text"
//                 className="w-full p-2 border rounded"
//                 placeholder="rgba(0,0,0,0.5) or #000000"
//                 value={content?.overlay?.color || 'rgba(0,0,0,0.5)'}
//                 onChange={(e) => updateContent('overlay', {
//                   ...content.overlay,
//                   color: e.target.value
//                 })}
//               />
//             </div>
            
//             <div className="mb-2">
//               <label className="block text-sm mb-1">Blend Mode</label>
//               <select
//                 className="w-full p-2 border rounded"
//                 value={content?.overlay?.blendMode || 'normal'}
//                 onChange={(e) => updateContent('overlay', {
//                   ...content.overlay,
//                   blendMode: e.target.value
//                 })}
//               >
//                 <option value="normal">Normal</option>
//                 <option value="multiply">Multiply</option>
//                 <option value="screen">Screen</option>
//                 <option value="overlay">Overlay</option>
//                 <option value="darken">Darken</option>
//                 <option value="lighten">Lighten</option>
//                 <option value="color-dodge">Color Dodge</option>
//                 <option value="color-burn">Color Burn</option>
//                 <option value="hard-light">Hard Light</option>
//                 <option value="soft-light">Soft Light</option>
//                 <option value="difference">Difference</option>
//                 <option value="exclusion">Exclusion</option>
//               </select>
//             </div>
//           </>
//         )}
//       </div>
      
//       {/* Button Settings */}
//       <div className="mb-4 p-3 border rounded bg-gray-50">
//         <h4 className="font-medium mb-2">Button Settings</h4>
        
//         <div className="mb-2">
//           <label className="block text-sm mb-1">Button Text</label>
//           <input
//             type="text"
//             className="w-full p-2 border rounded"
//             value={content?.ctaButtonText || ''}
//             onChange={(e) => updateContent('ctaButtonText', e.target.value)}
//           />
//         </div>
        
//         <div className="mb-2">
//           <label className="block text-sm mb-1">Button Link</label>
//           <input
//             type="text"
//             className="w-full p-2 border rounded"
//             value={content?.ctaButtonLink || ''}
//             onChange={(e) => updateContent('ctaButtonLink', e.target.value)}
//           />
//         </div>
        
//         <div className="mb-2">
//           <label className="block text-sm mb-1">Button Style</label>
//           <select
//             className="w-full p-2 border rounded"
//             value={content?.buttonStyle || 'primary'}
//             onChange={(e) => updateContent('buttonStyle', e.target.value)}
//           >
//             <option value="primary">Primary</option>
//             <option value="secondary">Secondary</option>
//             <option value="outline">Outline</option>
//             <option value="link">Link</option>
//           </select>
//         </div>
        
//         <div className="mb-2">
//           <label className="block text-sm mb-1">Button Size</label>
//           <select
//             className="w-full p-2 border rounded"
//             value={content?.buttonSize || 'medium'}
//             onChange={(e) => updateContent('buttonSize', e.target.value)}
//           >
//             <option value="small">Small</option>
//             <option value="medium">Medium</option>
//             <option value="large">Large</option>
//           </select>
//         </div>
        
//         <div className="flex items-center mb-2">
//           <input
//             type="checkbox"
//             className="mr-2"
//             checked={content?.openInNewTab || false}
//             onChange={(e) => updateContent('openInNewTab', e.target.checked)}
//           />
//           <label className="text-sm">Open link in new tab</label>
//         </div>
//       </div>
      
//       {/* Layout Settings */}
//       <div className="mb-4">
//         <label className="block text-sm font-medium mb-1">Content Alignment</label>
//         <select
//           className="w-full p-2 border rounded"
//           value={content?.alignment || 'center'}
//           onChange={(e) => updateContent('alignment', e.target.value)}
//         >
//           <option value="left">Left</option>
//           <option value="center">Center</option>
//           <option value="right">Right</option>
//         </select>
//       </div>
      
//       <div className="mb-4">
//         <label className="block text-sm font-medium mb-1">Content Width</label>
//         <select
//           className="w-full p-2 border rounded"
//           value={content?.contentWidth || 'medium'}
//           onChange={(e) => updateContent('contentWidth', e.target.value)}
//         >
//           <option value="narrow">Narrow</option>
//           <option value="medium">Medium</option>
//           <option value="wide">Wide</option>
//           <option value="full">Full Width</option>
//         </select>
//       </div>
      
//       <div className="mb-4">
//         <label className="block text-sm font-medium mb-1">Vertical Padding</label>
//         <select
//           className="w-full p-2 border rounded"
//           value={content?.verticalPadding || 'medium'}
//           onChange={(e) => updateContent('verticalPadding', e.target.value)}
//         >
//           <option value="small">Small</option>
//           <option value="medium">Medium</option>
//           <option value="large">Large</option>
//           <option value="xlarge">Extra Large</option>
//         </select>
//       </div>
//     </div>
//   );
// };

// export default CtaForm;





